import { ActiveVariantType } from './types';
import * as React from 'react';

type ActiveVariantTypeSetter = (newType: ActiveVariantType) => void;
type ActiveVariantTypeContextValues = [
  ActiveVariantType,
  ActiveVariantTypeSetter,
];

const SelectedActiveVariantTypeContext =
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  React.createContext<ActiveVariantTypeContextValues>(null);

/**
 * @description A hook for reading and setting the selected variant type prop.
 */
function useActiveVariantType() {
  const context = React.useContext(SelectedActiveVariantTypeContext);

  if (!context) {
    throw new Error(
      'useActiveVariantType must be used within a ActiveVariantTypeProvider',
    );
  }

  return context;
}

function ActiveVariantTypeProvider(props: any) {
  const [selectedActiveVariantType, setSelectedActiveVariantType] =
    React.useState<ActiveVariantType>('short');

  const value = React.useMemo(
    () => [selectedActiveVariantType, setSelectedActiveVariantType],
    [selectedActiveVariantType],
  );

  return <SelectedActiveVariantTypeContext.Provider value={value} {...props} />;
}

export { ActiveVariantTypeProvider, useActiveVariantType };
